import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { GovtServersAddPageComponent } from './govt-servers-add-page.component';

const routes: Routes = [
  {
    path: 'govt-servers-add',
    data: { name: 'Add Government-Servers', isTab: false },
    component: GovtServersAddPageComponent,
    // Route for the main "Add Government-Servers" page.
  },
  {
    path: 'govt-servers-add/:stateServerId',
    component: GovtServersAddPageComponent,
    // Route with 'stateServerId' parameter, but without 'listType'.
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
  // Importing the RouterModule and configuring the routes for child components.
})
export class GovtServersAddPageRoutingModule {}
// Defining and exporting the routing module for GovtServersAddPageComponent.
